import {
  diagnosticLabel,
  lifecycleLabel,
} from '../../materiels/materielDisplayMaps';

const LIFECYCLE_CLASS = {
  EN_STOCK: 'bg-amber-50 text-amber-900 border-amber-200',
  AFFECTE: 'bg-primary-50 text-primary-800 border-primary-200',
  RETOUR: 'bg-slate-100 text-slate-700 border-slate-200',
  HORS_SERVICE: 'bg-gray-200 text-gray-700 border-gray-300',
};

const DIAGNOSTIC_CLASS = {
  Opérationnel: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  'À vérifier': 'bg-amber-50 text-amber-900 border-amber-200',
  Erreur: 'bg-red-50 text-red-800 border-red-200',
};

/**
 * Double badge : cycle de vie + diagnostic (diagnostic seulement si Affecté).
 */
export default function MaterielBadges({ item, className = '' }) {
  const status = item?.status || 'EN_STOCK';
  const life = lifecycleLabel(status);
  const diag = diagnosticLabel(item);

  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`}>
      <span
        className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium border ${
          LIFECYCLE_CLASS[status] || LIFECYCLE_CLASS.EN_STOCK
        }`}
      >
        {life}
      </span>
      {diag ? (
        <span
          className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium border ${
            DIAGNOSTIC_CLASS[diag] || DIAGNOSTIC_CLASS['À vérifier']
          }`}
        >
          {diag}
        </span>
      ) : null}
    </div>
  );
}
